import types from './types';
import globalTypes from '../globalTypes';
import API from '../../utils/api';
import ModalsUtil from '../../utils/modals';
import WSocket from '../../utils/websocket';
import SoundsUtil from '../../utils/sounds';
import language from '../../language';

export const loadUser = () => async dispatch => {
    const response = await API({
        path: '/user/get'
    });

    if(response.success) {
        dispatch({
            type: types.loaded,
            payload: response
        });

        if(response.user)
            WSocket.authorize(response.user.userId, false);
    }
}

export const closeGame = () => dispatch => {
    ModalsUtil.hideGame();

    setTimeout(() => {
        dispatch({
            type: types.game,
            payload: null
        });
    }, 550);
}

export const openGame = id => async dispatch => {
    ModalsUtil.showGame();

    dispatch({
        type: types.toggleButton,
        payload: 'game'
    });

    const response = await API({
        path: '/games/open',
        body: {
            id
        }
    });

    if(response.success)
        dispatch({
            type: types.game,
            payload: response.game
        });

    dispatch({
        type: types.toggleButton,
        payload: 'game'
    });
}

export const toggleFavorite = gameId => async dispatch => {
    SoundsUtil.gameClick();

    dispatch({
        type: globalTypes.app.notify,
        payload: null
    });

    dispatch({
        type: types.toggleButton,
        payload: 'favorite'
    });

    const response = await API({
        path: '/games/favorite',
        body: {
            gameId
        }
    });

    if(response.success)
        dispatch({
            type: types.favorites[response.status ? 'add' : 'remove'],
            payload: gameId
        });
    else
        dispatch({
            type: globalTypes.app.notify,
            payload: language(response.error)
        });


    dispatch({
        type: types.toggleButton,
        payload: 'favorite'
    });
}

export const setGameTab = (tab, current_tab) => {
    SoundsUtil.click();

    return {
        type: types.games_tab,
        payload: tab === current_tab ? 'inactive' : tab
    }
}

export const changeAvatar = num => async dispatch => {
    SoundsUtil.click();

    dispatch({
        type: globalTypes.app.notify,
        payload: null
    });

    dispatch({
        type: types.toggleButton,
        payload: 'changeAvatar'
    });

    const response = await API({
        path: '/user/avatar',
        body: {
            num
        }
    });

    if(response.success) {
        dispatch({
            type: types.avatar,
            payload: num
        });
    } else {
        dispatch({
            type: globalTypes.app.notify,
            payload: language(response.error)
        });
    }

    dispatch({
        type: types.toggleButton,
        payload: 'changeAvatar'
    });
}

export const changePassword = data => async dispatch => {
    SoundsUtil.click();

    dispatch({
        type: globalTypes.app.notify,
        payload: null
    });

    dispatch({
        type: types.toggleButton,
        payload: 'changePassword'
    });

    const response = await API({
        path: '/user/password',
        body: data
    });

    if(response.success) {
        dispatch({
            type: globalTypes.app.notify,
            payload: language(response.message)
        });

        document.dispatchEvent(new CustomEvent('password.changed'));
    } else {
        dispatch({
            type: globalTypes.app.notify,
            payload: language(response.error)
        });
    }

    dispatch({
        type: types.toggleButton,
        payload: 'changePassword'
    });
}

export const getBonus = ({
    type,
    bonus
}) => async dispatch => {
    SoundsUtil.click();

    dispatch({
        type: globalTypes.app.notify,
        payload: null
    });

    dispatch({
        type: types.toggleButton,
        payload: 'take_bonus'
    });
    
    const response = await API({
        path: "/user/bonus",
        body: {
            type,
            bonus
        }
    });

    if(!response.success)
        dispatch({
            type: globalTypes.app.notify,
            payload: language(response.error)
        });

    dispatch({
        type: types.toggleButton,
        payload: 'take_bonus'
    });
}